<template>
  <div>
    <el-card class="box-card" body-style="min-height:70vh;">
      <div slot="header" class="clearfix">
        <div class="flex-between">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="用户搜索：" prop="name">
              <el-input v-model="searchForm.name" placeholder="请输入用户名称/手机号搜索" class="mt-search-width"></el-input>
            </el-form-item>
            <el-form-item label="用户类型：" prop="memberLeveType">
              <el-select v-model="searchForm.memberLeveType" placeholder="请选择" class="mt-search-width">
                <el-option
                  v-for="item in memberLeveTypeArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="会员等级：" prop="memberLevelId">
              <el-select v-model="searchForm.memberLevelId" placeholder="请选择" class="mt-search-width">
                <el-option
                  v-for="item in memberLevelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间筛选：" prop="date">
              <el-date-picker
                v-model="searchForm.date"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
              <el-button style="margin-left: 24px;" @click="exportExcelBtn">数据导出</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="headPicture"
            label="头像">
            <template slot-scope="scope">
              <el-image
                style="width: 40px;"
                :src="scope.row.headPicture == null ? imgServer+'no_img.png' : scope.row.headPicture"
                :preview-src-list="[scope.row.headPicture]"
                fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="昵称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="用户类型">
            <template slot-scope="scope">
              <span>{{scope.row.memberLevelType == 1 ? '会员' : scope.row.memberLevelType == 2 ? '内部员工' : scope.row.memberLevelType == 3 ? '合伙人' : '普通用户'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="memberLevelName"
            label="会员等级">
            <template slot-scope="scope">
              <span>{{scope.row.memberLevelName == null ? '--' : scope.row.memberLevelName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="money"
            label="余额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="integral"
            label="积分">
          </el-table-column>
          <el-table-column
            align="center"
            prop="parentNickName"
            label="推荐人">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="注册时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="editBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="hxBtn(scope.row.id)" type="text" size="small">核销记录</el-button>
              <el-button @click="changeMoneyBtn(scope.row.id,scope.row.money)" type="text" size="small">变更余额</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <el-dialog
      title="编辑用户"
      :visible.sync="editShow"
      width="960px">
      <el-form :model="editForm" :inline="true" label-width="140px">
        <el-form-item label="昵称：" prop="name">{{memberInfo.nickName}}</el-form-item>
        <el-form-item label="手机号：" prop="name">{{memberInfo.phone}}</el-form-item>
        <el-form-item label="推荐人：" prop="name">{{memberInfo.parentNickName == null ? '--' : memberInfo.parentNickName}}</el-form-item>
        <el-form-item label="用户类型：" prop="name">
          <el-select v-model="editForm.memberLeveType" placeholder="请选择" style="width: 424px">
            <el-option
              v-for="item in memberLeveTypeArr"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会员等级：" prop="name">
          <el-select v-model="editForm.memberLevelId" placeholder="请选择" style="width: 424px">
            <el-option
              v-for="item in memberLevelList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分公司：">
          <el-select v-model="editForm.enterpriseId" placeholder="请选择" style="width: 424px">
            <el-option
              v-for="item in enterpriseIdArr"
              :key="item.id"
              :label="item.enterpriseName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="代理渠道：">
          <el-select v-model="editForm.agentChannelId" placeholder="请选择" style="width: 424px">
            <el-option
              v-for="item in agentChannelIdArr"
              :key="item.id"
              :label="item.agentChannelName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推广员（一级）：" prop="enableFirstParentId">
          <div style="width: 424px">
            <el-switch
              v-model="editForm.enableFirstParentId"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </div>
        </el-form-item>
        <el-form-item label="核销员：" prop="isWriteOff">
          <div style="width: 424px">
            <el-switch
              v-model="editForm.isWriteOff"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </div>
        </el-form-item>
        <el-form-item label="年卡用户：" prop="isYearCard">
          <div style="width: 424px">
            <el-switch
              v-model="editForm.isYearCard"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </div>
        </el-form-item>
        <el-form-item label="状态：" prop="status">
          <div style="width: 424px;">
            <el-switch v-model="editForm.status">
            </el-switch>
          </div>
        </el-form-item>
        <el-form-item label="  ">
          <div style="width: 424px;">
            <el-button type="primary" @click="saveEditBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 变更余额弹窗 -->
    <el-dialog
      title="变更余额"
      :visible.sync="changeMoneyShow"
      width="960px">
      <el-form :model="changeMoneyForm" :rules="changeMoneyRules" label-width="140px">
        <el-form-item label="当前余额：">
          <span>{{currentMoney}}</span>
        </el-form-item>
        <el-form-item label="选择类型：" prop="type">
          <el-radio-group v-model="changeMoneyForm.type">
            <el-radio :label="1">增加余额</el-radio>
            <el-radio :label="2">减少余额</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="changeMoneyForm.type == 1 ? '增加余额：' : '减少余额：'" prop="money">
          <el-input style="width: 420px;" v-model="changeMoneyForm.money" placeholder="请输入余额"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="changeMoneySaveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { queryMinAppUserPageList, queryAllUserMemberLevelList, fetchWebMinAppUserDetailById, updateMinAppUser, exportExcel, queryEnterprisePageList, addMoney, subMoney } from '@/api/user'
import { queryAllAgentChannelList } from '@/api/commission'
export default {
  name: 'User',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      infoId: '',
      fullscreenLoading: false,
      searchForm: {
        name: '',
        memberLeveType: '',
        memberLevelId: '',
        date: ['', '']
      },
      memberLeveTypeArr: this.$memberLeveTypeArr,
      memberLevelList: [],
      // 编辑用户
      editShow: false,
      memberInfo: {
        nickName: '',
        phone: '',
        parentNickName: ''
      },
      editForm: {
        name: '',
        memberLeveType: '',
        memberLevelId: '',
        enterpriseId:'',
        agentChannelId:'',
        enableFirstParentId: false,
        isWriteOff:false,
        isYearCard:false,
        status: false
      },
      enterpriseIdArr:[],
      agentChannelIdArr:[],
      // 变更余额
      currentMoney:'',
      changeMoneyShow:false,
      changeMoneyForm:{
        type:1,
        money:''
      },
      changeMoneyRules: {
        type: [
          { required: true, message: '请选择变更类型', trigger: 'blur' }
        ],
        money: [
          { required: true, message: '请输入余额', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    "editForm.memberLeveType": {
      handler(newVal, oldVal) {
        this.memberLevelListFun(newVal);
      }
    }
  },
  mounted () {
    this.memberLevelListFun(this.searchForm.memberLeveType);
    this.enterpriseFun();
    this.agentChannelFun();
    this.getInfoList()
  },
  methods: {
    // 分公司数据
    enterpriseFun(){
      var that = this;
      queryEnterprisePageList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.enterpriseIdArr = data
        }
        if (res.errorCode === '4002') {
          that.editForm.enterpriseId = '';
          that.enterpriseIdArr = []
        }
      })
    },
    // 代理渠道数据
    agentChannelFun(){
      var that = this;
      queryAllAgentChannelList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.agentChannelIdArr = data
        }
        if (res.errorCode === '4002') {
          that.editForm.agentChannelId = '';
          that.agentChannelIdArr = []
        }
      })
    },
    // 变更余额弹窗-打开弹窗
    changeMoneyBtn(infoId, currentMoney){
      this.currentMoney = currentMoney;
      this.infoId = infoId;
      this.changeMoneyShow = true;
    },
    // 变更余额弹窗-保存弹窗
    changeMoneySaveBtn(){
      var that = this;
      var infoId = that.infoId;
      var changeMoneyForm = that.changeMoneyForm;
      if(changeMoneyForm.money == ''){
        this.$message.error('请输入余额')
        return false
      }
      if(changeMoneyForm.type == 1){
        // 增加余额
        addMoney({id:infoId,money:changeMoneyForm.money}).then((res) => {
          if (res.errorCode === '0000') {
            let data = res.data
            that.$message.success(res.msg);
            that.getInfoList();
            that.changeMoneyShow = false;
            that.changeMoneyForm.type = 1;
            that.changeMoneyForm.money = '';
          }
          if (res.errorCode === '1001') {
            that.$message.error(res.msg);
          }
        })
      }else{
        // 减少余额
        subMoney({id:infoId,money:changeMoneyForm.money}).then((res) => {
          if (res.errorCode === '0000') {
            let data = res.data
            that.$message.success(res.msg);
            that.getInfoList();
            that.changeMoneyShow = false;
            that.changeMoneyForm.type = 1;
            that.changeMoneyForm.money = '';
          }
          if (res.errorCode === '1001') {
            that.$message.error(res.msg);
          }
        })
      }
    },
    // 导出操作
    exportExcelBtn(){
      var that = this;
      let searchName = that.searchForm.name
      let tabCurrent = that.tabCurrent
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      exportExcel({ webSearchStr: searchName, startCreateDate:startDate, endCreateDate:endDate,status:tabCurrent }).then((res) => {
          // 处理二进制数据并创建 Blob 对象
          const blobObj = new Blob([res], { type: 'application/octet-stream' });
          // 创建一个链接并设置下载属性
          const downloadLink = document.createElement("a");
          let url = window.URL || window.webkitURL || window.moxURL; // 兼容不同浏览器的 URL 对象
          url = url.createObjectURL(blobObj);
          downloadLink.href = url;
          downloadLink.download = '用户列表'+new Date().getTime()+'.xlsx'; // 设置下载的文件名
          // 将链接添加到 DOM 中，模拟点击
          document.body.appendChild(downloadLink);
          downloadLink.click();
          // 移除创建的链接和释放 URL 对象
          document.body.removeChild(downloadLink);
          window.URL.revokeObjectURL(url);
      })
    },
    /* 会员等级列表 */
    memberLevelListFun (memberLevelType) {
      var that = this
      queryAllUserMemberLevelList({memberLevelType:memberLevelType}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.memberLevelList = data
        }
        if (res.errorCode === '4002') {
          that.editForm.memberLevelId = '';
          that.memberLevelList = []
        }
      })
    },
    /* 跳转核销记录页面 */
    hxBtn (infoId) {
      this.$router.push({path: '/writeoff_record', query: {dataId: infoId}})
    },
    /* 编辑用户 */
    editBtn (infoId) {
      var that = this
      that.infoId = infoId
      fetchWebMinAppUserDetailById({ id: infoId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.editShow = true
          that.memberInfo = data
          that.editForm.memberLevelId = data.memberLevelId
          that.editForm.enterpriseId = data.enterpriseId
          that.editForm.agentChannelId = data.agentChannelId
          that.editForm.memberLeveType = data.memberLevelType
          that.editForm.status = data.status == 1 ? true : false
          that.editForm.enableFirstParentId = data.enableFirstParentId == 1 ? true : false
          that.editForm.isWriteOff = data.isWriteOff == 1 ? true : false
          that.editForm.isYearCard = data.isYearCard == 1 ? true : false
        }
      })
    },
    /* 编辑用户弹窗-保存 */
    saveEditBtn () {
      var that = this;
      var infoId = that.infoId;
      var memberLeveType = that.editForm.memberLeveType;
      var memberLevelId = that.editForm.memberLevelId;
      var enterpriseId = that.editForm.enterpriseId;
      var agentChannelId = that.editForm.agentChannelId;
      var enableFirstParentId = that.editForm.enableFirstParentId == true ? 1 : 0;
      var isWriteOff = that.editForm.isWriteOff == true ? 1 : 0;
      var isYearCard = that.editForm.isYearCard == true ? 1 : 0;
      var status = that.editForm.status == true ? 1 : 0;
      let passData = {
        id: infoId,
        enableFirstParentId: enableFirstParentId,
        isWriteOff: isWriteOff,
        isYearCard: isYearCard,
        memberLevelId: memberLevelId,
        memberLevelType: memberLeveType,
        status: status,
        enterpriseId:enterpriseId,
        agentChannelId:agentChannelId
      }
      that.fullscreenLoading = true;
      updateMinAppUser(passData).then((res) => {
        that.fullscreenLoading = false;
        if (res.errorCode === '0000') {
          that.editShow = false
          that.getInfoList();
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let memberLeveType = that.searchForm.memberLeveType
      let memberLevelId = that.searchForm.memberLevelId
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      let page = that.currentPage
      queryMinAppUserPageList({ webSearchStr: searchName,memberLevelType:memberLeveType,memberLevelId:memberLevelId,startCreateDate:startDate,endCreateDate:endDate,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/User.vue